import { Circle } from '@tink/core/src/components/atoms/Circle/Circle';
import { css, styled } from '../../../core/theme/styled';

type LineItemProps = {
  center?: boolean;
};

export const StyledFlexLi = styled.li<LineItemProps>`
  width: 100%;
  display: flex;
  align-items: baseline;
  ${(props) =>
    props.center &&
    css`
      align-items: center;
    `}
  padding: ${(props) => props.theme.sizes.xxsmall} 0;
`;

export const Index = styled.span`
  color: ${(props) => props.theme.configuration.primaryColor};
  font-size: ${(props) => props.theme.sizes.xsmall};
`;

export const StyledCircle = styled(Circle)`
  margin-top: -2px;
  margin-right: ${(props) => props.theme.sizes.xxsmall};

  && {
    background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
  }
`;
